import * as RadixLabel from '@radix-ui/react-label';
import Select, { GroupBase, OptionsOrGroups, PropsValue } from 'react-select';
import './SelectInput.css';

export const SelectInput = ({
  label,
  id,
  options,
  value,
  onChange,
}: {
  label: string;
  id: string;
  options: { value: any; label: string }[];
  value?: string;
  onChange: (value: any) => void;
}) => {
  return (
    <div className="SelectInputRoot" key={id}>
      <RadixLabel.Root className="LabelRoot" htmlFor={id}>
        {label}
      </RadixLabel.Root>
      <Select
        unstyled
        isSearchable
        id={id}
        options={
          options as unknown as OptionsOrGroups<number, GroupBase<number>>
        }
        value={
          options.find(
            (option) => option.value === value || option.value?.type === value
          ) as unknown as PropsValue<number>
        }
        placeholder=""
        className="react-select-container"
        classNamePrefix="react-select"
        onChange={(newValue) => {
          const option = newValue as unknown as {
            value: any;
            label: string;
          };
          const inputValue: any = option?.value;
          onChange(inputValue);
        }}
      />
    </div>
  );
};
